module.exports = __webpack_public_path__ + "static/media/unis-unicorn.bb91f315.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/unis-unicorn.png
 ** module id = 525
 ** module chunks = 0
 **/